<template>
	<section id="welcome-trust" class="welcome-trust">
		<h2 class="welcome-trust__title">{{ $t('welcome_why_eduson_title') }}</h2>
		<template v-if="currentLocale === 'ru'">
			<ul class="feedback-wrapper" :class="{ 'is-active': isActive }" >
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/rostelekom-ru@2x.png" class="feedback-logo" height="75" alt="">
						</div>
						<p class="feedback-text">
							Эдюсон — это удобный и экономически эффективный инструмент для того, чтобы обучить 140 тысяч человек по всей России.
						</p>
						<p class="feedback-text">
							Удобные форматы курсов и технология позволяют учиться в тот момент, когда хочется, и из любого места, где застигнет такое желание.
						</p>
						<div class="feedback-author-holder">
							<p class="bold-font">Никита Черкасенко</p>
							<p>Директор Департамента оценки, обучения и развития персонала</p>
						</div>
					</div>
				</li>
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/rzhd-logo.png" class="feedback-logo" height="55" alt="">
						</div>
						<p class="feedback-text">
							Лучшие электронные курсы, которые я только видел! Отличная подача материала! Несмотря на наличие западных примеров – эти примеры живые для передачи информации слушателям.
						</p>
						<p class="feedback-text">
							Навыки из курсов хочется применять на практике: чек-листы, формулы Excel и др.
						</p>
						<div class="feedback-author-holder">
							<p class="bold-font">Александр Горовых</p>
							<p>Сотрудник подразделения «Аппарат управления»</p>
						</div>
					</div>
				</li>
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/nspk-logo.png" class="feedback-logo" height="45" alt="">
						</div>
						<p class="feedback-text">
							В Эдюсон прекрасно оформлена аналитика, которой мы активно пользуемся, так как у нас есть регулярная полугодовая и годовая отчетность.
						</p>
						<div class="feedback-author-holder">
							<p class="bold-font">Инна Карелина</p>
							<p>Руководитель по оценке, обучению и развитию персонала</p>
						</div>
					</div>
				</li>
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/kazahk-telecom-logo.png" class="feedback-logo" height="75" alt="">
						</div>
						<p class="feedback-text">
							За время нашего партнерства команда Эдюсон проявила себя как профессионалы, качественно и быстро решающие поставленные задачи и возникающие вопросы.
						</p>
						<div class="feedback-author-holder">
							<p class="bold-font">Берик Битабаров</p>
							<p>Управляющий директор по персоналу</p>
						</div>
					</div>
				</li>
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/danfoss-logo.png" class="feedback-logo" height="70" alt="">
						</div>
						<p class="feedback-text">
							Платформа Эдюсон – эффективный инструмент для быстрой адаптации новых сотрудников в компании. Они проходят тестирование, руководители назначают
							им программы обучения. Нам важно развивать soft skills у отраслевых сотрудников, большая библиотека Эдюсон в этом помогает.
						</p>
						<div class="feedback-author-holder">
							<p class="bold-font">Анна Каткова</p>
							<p>Директор по персоналу</p>
						</div>
					</div>
				</li>
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/bi-group-logo.png" class="feedback-logo" height="50" alt="">
						</div>
						<p class="feedback-text">
							Отличительной чертой Эдюсон является пополняющаяся база онлайн-курсов высокого качества по широкому спектру направлений.
						</p>
						<p class="feedback-text">
							Большой набор цифровых материалов позволяет эффективно обучать слушателей посредствам передовых форматов.
						</p>
						<div class="feedback-author-holder">
							<p class="bold-font">Баспаева Ольга</p>
							<p>Директор BI University</p>
						</div>
					</div>
				</li>
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/megapolis-kaz-logo.png" class="feedback-logo" height="75" alt="">
						</div>
						<p class="feedback-text">
							Эдюсон для нас – это возможность получить “прокачку” из любой точки мира, достаточно иметь при себе доступ к интернету, проходить
							обучение без отрыва от работы или домашних дел. Постоянно обновляющийся каталог курсов на русском и английском языках.
						</p>
						<div class="feedback-author-holder">
							<p class="bold-font">Валерия Кан</p>
							<p>Менеджер по обучению и развитию</p>
						</div>
					</div>
				</li>
			</ul>
			<div class="welcome-trust__bottom">
				<button @click="showCards" class="app-btn app-btn--round app-btn--outline" type="button">
					<template v-if="!isActive">
						Смотреть все
					</template>
					<template v-else>
						Скрыть
					</template>
				</button>
			</div>
		</template>
		<template v-if="currentLocale === 'en'">
			<ul class="feedback-wrapper feedback-wrapper--en">
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/gett@2x.png" class="feedback-logo" alt="">
						</div>
						<p class="feedback-text">Training a global team is a challenge. Our marketing and sales specialists work in New York, London, Moscow, and Tel-Aviv.</p>
						<p class="feedback-text">Eduson offers a modern and efficient approach to employee training. The stories from successful entrepreneurs motivate the team, while the sales techniques from the best coaches increase efficiency.</p>
						<p class="feedback-text">High-quality courses and a convenient interface have radically changed our employees' opinion about online learning.</p>
						<div class="feedback-author-holder">
							<span class="bold-font">CEO and Founder</span>
						</div>
					</div>
				</li>
				<li class="feedback-card">
					<div class="feedback-text-holder">
						<div class="feedback-header">
							<img src="../../../static/images/welcome/lafarge@2x.png" class="feedback-logo"  alt="">
						</div>
						<p class="feedback-text">In Eduson courses, complex concepts are explained in a lively, interesting way that closely reflects business realities.</p>
						<p class="feedback-text">High quality courses and a convenient interface have radically improved our employees' course completion ratio.</p>
						<div class="feedback-author-holder">
							<span class="bold-font">Head of Personnel Recruitment, <br />Assessment and Adaptation Department</span>
						</div>
					</div>
				</li>
			</ul>
		</template>
	</section>
</template>

<script>
export default {
	name: 'WhyEduson',

	data() {
		return {
			currentLocale: window.currentLocale,
			isActive: false
		}
	},

	methods: {
		showCards() {
			this.isActive = !this.isActive;
		}
	}
}
</script>
